import { initializeConversationReadingPaneInSxS } from '../actions/internalActions';
import { assertNever } from 'owa-assert';
import {
    lazyLoadConversationReadingPane,
    lazySetItemIdToScrollTo,
} from 'owa-mail-reading-pane-store';
import {
    onSxSReadingPaneChange,
    SxSReadingPaneMode,
    getOrCreateSxSStoreData,
    onBeforeSxSReadingPaneChange,
} from 'owa-sxs-store';
import { PreviewPaneSelectionSource } from 'owa-sxs-store';
import { orchestrator } from 'satcheljs';

orchestrator(initializeConversationReadingPaneInSxS, async actionMessage => {
    const {
        readingPaneStrategy,
        previewPaneSelectionSource,
        parentItemId,
        instrumentationContext,
        sxsId,
    } = actionMessage;
    if (!readingPaneStrategy || !readingPaneStrategy.conversationId) {
        return;
    }

    const sxsStore = getOrCreateSxSStoreData(sxsId);
    if (
        sxsStore.readingPaneState &&
        sxsStore.readingPaneState.mode === SxSReadingPaneMode.ConversationReadingPane &&
        sxsStore.readingPaneState.conversationId &&
        sxsStore.readingPaneState.conversationId.Id === readingPaneStrategy.conversationId.Id
    ) {
        // SxS is already showing the conversation
        if (parentItemId && shouldScrollToItemInSameConversation(previewPaneSelectionSource)) {
            lazySetItemIdToScrollTo.importAndExecute(
                readingPaneStrategy.conversationId.Id,
                parentItemId.Id
            );
        }
        return;
    }

    onBeforeSxSReadingPaneChange(readingPaneStrategy.conversationId.Id);

    await lazyLoadConversationReadingPane.importAndExecute(
        readingPaneStrategy.conversationId,
        instrumentationContext,
        readingPaneStrategy.conversationSubject,
        readingPaneStrategy.conversationCategories,
        readingPaneStrategy.itemIdToScrollTo
    );

    onSxSReadingPaneChange(
        {
            mode: SxSReadingPaneMode.ConversationReadingPane,
            conversationId: readingPaneStrategy.conversationId,
            conversationCategories: readingPaneStrategy.conversationCategories,
            conversationSubject: readingPaneStrategy.conversationSubject,
        },
        sxsId
    );

    if (parentItemId) {
        lazySetItemIdToScrollTo.importAndExecute(
            readingPaneStrategy.conversationId.Id,
            parentItemId.Id
        );
    }
});

/**
 * When an attachment is previewed in the same conversation,
 * ensure its parent email item is visible in the reading pane
 * for the cases of conversation attachment well and mail list
 */
function shouldScrollToItemInSameConversation(
    previewPaneSelectionSource: PreviewPaneSelectionSource
): boolean {
    switch (previewPaneSelectionSource) {
        case PreviewPaneSelectionSource.MailList:
        case PreviewPaneSelectionSource.ConversationAttachmentWell:
            return true;
        case PreviewPaneSelectionSource.ReadingPane:
        case PreviewPaneSelectionSource.FilesHub:
        case PreviewPaneSelectionSource.PhotoHub:
        case PreviewPaneSelectionSource.GroupFilesHub:
        case PreviewPaneSelectionSource.ConsumerGroupFilesHub:
        case PreviewPaneSelectionSource.Deeplink:
        case PreviewPaneSelectionSource.FileSuggestion:
        case PreviewPaneSelectionSource.LinkSuggestion:
        case PreviewPaneSelectionSource.ComposeDocLink:
        case PreviewPaneSelectionSource.ReadingPaneDocLink:
        case PreviewPaneSelectionSource.FolderTree:
            return false;
        default:
            return assertNever(previewPaneSelectionSource);
    }
}
